// EAKC Episode 2: RAG Pipeline Deep Dive — Scene Timing
// Reuses COLORS, FONTS, SPRING from Episode 1
//
// GROUND TRUTH (2026-07-19): this scene order mirrors EAKC's REAL end-to-end
// retrieval pipeline, taken from a live prod chat trace ("Explain EAKC's
// retrieval pipeline end to end"). The 18 real stages, in order:
//   query → intent classification/routing → acronym expansion → query rewrite →
//   source-aware decomposition → semantic cache check → hybrid retrieval
//   (pgvector + BM25) + title-based retrieval → cross-source linking →
//   artifact-tier quarantine (drops test/eval/screenshot chunks; ~158 primary
//   kept) → knowledge-graph augmentation → CRAG quality gate → cross-encoder
//   reranking → file-diversity quota → pre-LLM token gating → synthesis
//   (strict-source, gemini-2.5-flash, [Source N]) → claim grounding + citation
//   guard → completeness critic (splices omitted facts) → cited-only footer prune.
// Grouped into the scenes below (Step 1–9). Do NOT invent stages.

export { COLORS, FONTS, SPRING } from "../EAKCArchitecture/constants";

// === Scene Timing (in frames at 30fps) ===
export const SCENE = {
  title: { start: 0, duration: 120 },            // 0:00-0:04
  queryInput: { start: 120, duration: 240 },     // 0:04-0:12  Step 1: Query, Intent & Acronyms
  queryRewrite: { start: 360, duration: 300 },   // 0:12-0:22  Step 2: Rewrite, Decompose & Cache
  hybridSearch: { start: 660, duration: 360 },   // 0:22-0:34  Step 3: Hybrid Retrieval
  quarantine: { start: 1020, duration: 240 },    // 0:34-0:42  Step 4: Artifact-Tier Quarantine
  graphAugment: { start: 1260, duration: 240 },  // 0:42-0:50  Step 5: Knowledge-Graph Augmentation
  crag: { start: 1500, duration: 240 },          // 0:50-0:58  Step 6: CRAG Quality Gate
  reranking: { start: 1740, duration: 240 },     // 0:58-1:06  Step 7: Rerank, Diversify & Token-Gate
  generation: { start: 1980, duration: 210 },    // 1:06-1:13  Step 8: Synthesis & Grounding
  completeness: { start: 2190, duration: 240 },  // 1:13-1:21  Step 9: Completeness & Citation Prune
  outro: { start: 2430, duration: 150 },         // 1:21-1:26
} as const;

// Contiguous sum: 120+240+300+360+240+240+240+240+210+240+150 = 2580 (86s @ 30fps)
export const TOTAL_DURATION = 2580;
export const FPS = 30;
export const WIDTH = 1920;
export const HEIGHT = 1080;

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
